class Alerts {
    constructor() {
        this.dismissButtons = Array.from(
            document.querySelectorAll(".js-alert-dismiss")
        );
        this.alerts = ".js-alert";
        this.headerMain = document.querySelector(".js-header-main");
    }

    showAlert() {
        const alerts = Array.from(document.querySelectorAll(this.alerts));
        alerts.forEach(alert => {
            const hash = alert.dataset.hash;
            const cookie = sessionStorage.getItem("alert");
            if (cookie !== hash) {
                alert.classList.add("alert--visible");
            }
        });
    }

    handleDismissButtonClick() {
        const dismissButtons = this.dismissButtons;
        dismissButtons.forEach(dismissButton => {
            dismissButton.addEventListener("click", e => {
                const alert = dismissButton.closest(this.alerts);
                const hash = alert.dataset.hash;
                sessionStorage.setItem("alert", hash);
                alert.classList.remove("alert--visible");
                this.headerMain.style.top = "0px";
            });
        });
    }

    init() {
        this.showAlert();
        this.handleDismissButtonClick();
    }
}

export default Alerts;



// WEBPACK FOOTER //
// ../project/craft/src/components/alerts/alerts.js